import { TilesType } from 'types/src/types';
import { Icon } from './Icon';
import { TooltipComponent } from '../layout';

export const AddVideoIcon = () => {
  return (
    <div className="flex items-center justify-center px-[9.5px] py-3 border-1 bg-bg-gray rounded-sm">
      <Icon name="youtube" width={17} height={12} className="bg-transparent" />
    </div>
  );
};

type Props = {
  onClick: (type: TilesType) => void;
};

export const AddVideoIconSm = ({ onClick }: Props) => {
  return (
    <TooltipComponent
      text="Add Video"
      className="bg-black text-white w-fit"
    >
      <div
        className="border-1 border-black/5 bg-white rounded-[8px] overflow-hidden size-8 custom-shadow hover:bg-bg-gray transition-all ease-in-out duration-300 flex items-center justify-center"
        onClick={() => onClick('add-video')}
      >
        <Icon
          name="youtube"
          width={17}
          height={12}
          className="bg-transparent"
        />
      </div>
    </TooltipComponent>
  );
};
